export default class ProtocolConstants {
  static MinimumThermostatTemperature = 3;
  static MaximumThermostatTemperature = 40.0;

  static Device1_0_12 = '1.0.12';
  static Device0_0_121 = '0.0.121';
  static Device1_0_130 = '1.0.130';
  static Device1_0_144 = '1.0.144';
  static Device1_0_145 = '1.0.145';
  static Device1_0_149 = '1.0.149';
  static Device1_0_152 = '1.0.152';
  static Device1_1_2 = '1.1.2';
  static Device1_1_3 = '1.1.3';
  static Device1_1_6 = '1.1.6';
  static Device1_1_16 = '1.1.16';
  static Device1_1_21 = '1.1.21';
  static Device1_1_46 = '1.1.46';
  static Device1_1_48 = '1.1.48';
  static Device1_1_49 = '1.1.49';
  static Device1_1_82 = '1.1.82';
  static Device1_2_2 = '1.2.2';
  static Device1_2_3 = '1.2.3';
  static Device1_2_16 = '1.2.16';
  static Device1_2_46 = '1.2.46';
  static Device1_2_48 = '1.2.48';
  static Device1_2_82 = '1.2.82';
  static Device1_3_2 = '1.3.2';
  static Device1_3_3 = '1.3.3';
  static Device1_3_6 = '1.3.6';
  static Device1_3_16 = '1.3.16';
  static Device1_3_21 = '1.3.21';
  static Device1_3_27 = '1.3.27';
  static Device1_3_28 = '1.3.28';
  static Device1_3_31 = '1.3.31';
  static Device1_3_46 = '1.3.46';
  static Device1_3_48 = '1.3.48';
  static Device1_3_49 = '1.3.49';
  static Device1_3_82 = '1.3.82';
  static Device1_5_9 = '1.5.9';
  static Device1_5_31 = '1.5.31';
  static Device1_5_88 = '1.5.88';
  static Device1_5_91 = '1.5.91';
  static Device1_5_97 = '1.5.97';
  static Device1_5_98 = '1.5.98';
  static Device1_5_121 = '1.5.121';
  static Device1_5_117 = '1.5.117';
  static Device1_5_118 = '1.5.118';
  static Device1_5_119 = '1.5.119';
  static Device2_0_130 = '2.0.130';
  static Device2_0_144 = '2.0.144';
  static Device2_0_145 = '2.0.145';
  static Device2_0_149 = '2.0.149';
  static Device2_2_17 = '2.2.17';
  static Device2_2_21 = '2.2.21';
  static Device2_2_27 = '2.2.27';
  static Device2_2_152 = '2.2.152';
  static Device2_4_2 = '2.4.2';
  static Device2_4_3 = '2.4.3';
  static Device2_4_6 = '2.4.6';
  static Device2_4_16 = '2.4.16';
  static Device2_4_17 = '2.4.17';
  static Device2_4_21 = '2.4.21';
  static Device2_4_46 = '2.4.46';
  static Device2_4_48 = '2.4.48';
  static Device2_4_49 = '2.4.49';
  static Device2_4_82 = '2.4.82';
  static Device5_0_3 = '5.0.3';
  static Device5_0_4 = '5.0.4';
  static Device5_0_5 = '5.0.5';
  static Device5_0_77 = '5.0.77';
  static Device6_8_2 = '6.8.2';
  static Device6_8_6 = '6.8.6';
  static Device6_8_16 = '6.8.16';
  static Device1_5_120 = '1.5.120';
  static Device1_0_78 = '1.0.78';
  static Device2_0_78 = '2.0.78';
  static Device1_0_79 = '1.0.79';
  static Device2_0_79 = '2.0.79';
  static Device1_0_31 = '1.0.31';
  static Device1_0_162 = '1.0.162';
  static Device2_0_162 = '2.0.162';
  static Device1_0_159 = '1.0.159';
  static Device2_0_159 = '2.0.159';
  static Device1_0_174 = '1.0.174';
  static Device2_0_174 = '2.0.174';
  static Device1_0_141 = '1.0.141';
  static Device2_0_141 = '2.0.141';
  static Device1_0_164 = '1.0.164';
  static Device2_0_164 = '2.0.164';
  static Device1_0_138 = '1.0.138';
  static Device2_0_138 = '2.0.138';
  static Device1_0_104 = '1.0.104';
  static Device1_0_105 = '1.0.105';

  static Device1_0_129 = '1.0.129';
  static Device1_0_137 = '1.0.137';
  static Device1_0_161 = '1.0.161';
  static Device2_0_129 = '2.0.129';
  static Device2_0_137 = '2.0.137';
  static Device2_0_161 = '2.0.161';

  static Device1_0_133 = '1.0.133';
  static Device1_0_135 = '1.0.135';
  static Device1_0_165 = '1.0.165';
  static Device2_0_133 = '2.0.133';
  static Device2_0_135 = '2.0.135';
  static Device2_0_165 = '2.0.165';

  static Device1_0_47 = '1.0.47';
  static Device2_0_47 = '2.0.47';

  static Device1_1_107 = '1.1.107';
  static Device1_2_107 = '1.2.107';
  static Device1_3_107 = '1.3.107';
  static Device2_2_107 = '2.2.107';
  static Device2_4_107 = '2.4.107';
  static Device6_8_107 = '6.8.107';

  static Device1_0_163 = '1.0.163';
  static Device2_0_163 = '2.0.163';
}
